import { useMemo, useState } from "react"

import { useMatch } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { FilterButton } from "@l2r-front/l2r-ui"

import { documentsFiltersConfig } from "../../constants/documentsFiltersConfig"
import { AUTHOR_FILTER, FILE_TYPE_FILTER, FILTERS } from "../../constants/filters"
import { I18N_NAMESPACE } from "../../constants/i18n"
import { useDocumentStateContext } from "../../contexts/DocumentContext"
import { DocumentFiltersFormPost } from "../../forms/DocumentFiltersForm/DocumentFiltersForm.post"
import { useDocumentAuthors } from "../../hooks/queries/useDocumentAuthors"
import { useDocumentTypes } from "../../hooks/queries/useDocumentTypes"

import * as Styled from "./MobileDocumentFilterButton.styled"

export function MobileDocumentFilterButton(props) {

    const {
        className,
        enabledFilters,
    } = props

    const { filters } = useDocumentStateContext()
    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const toggleFilter = () => setDisplayFilters(displayFilters => !displayFilters)
    const { data: documentTypes, isLoading: isLoadingDocumentTypes } = useDocumentTypes()
    const { data: users, isLoading: isLoadingUsers } = useDocumentAuthors()
    const isLoading = isLoadingDocumentTypes || isLoadingUsers
    const { t } = useTranslation(I18N_NAMESPACE)
    const isDetailView = useMatch(":networkId/:appId/:moduleId/:road/:detailId/*")

    const filterCount = useMemo(() => {
        if (filters && !isLoading) {
            return Object.entries(filters || {}).map(([filterKey, filterValues]) => {
                if (!enabledFilters.includes(filterKey)) {
                    return null
                }
                if (filterKey === AUTHOR_FILTER) {
                    return documentsFiltersConfig[filterKey].getValueList(filterKey, filterValues, users)
                } else if (filterKey === FILE_TYPE_FILTER) {
                    return documentsFiltersConfig[filterKey].getValueList(filterKey, filterValues, documentTypes)
                } else {
                    return documentsFiltersConfig[filterKey].getValueList(filterKey, filterValues, t)
                }
            }).flat().filter(v => !!v.value?.length).length
        }
        return 0
    }, [documentTypes, enabledFilters, filters, isLoading, t, users])

    if (isDetailView && filterCount === 0) {
        return null
    }

    return <FilterButton
        className={className}
        filterCount={filterCount}
        open={displayFilters}
        onClick={toggleFilter}
        onClose={closeFilters}
        title={isDetailView ? t(I18N_NAMESPACE, "containers.mobileDocumentFilterButton.title") : null}
    >
        {isDetailView ? <Styled.DocumentFilterList disableDelete /> :
            <DocumentFiltersFormPost close={closeFilters} displayFilters={displayFilters} enabledFilters={enabledFilters} />}
    </FilterButton>
}

MobileDocumentFilterButton.defaultProps = {
    enabledFilters: FILTERS,
}

MobileDocumentFilterButton.propTypes = {
    className: PropTypes.string,
    enabledFilters: PropTypes.arrayOf(PropTypes.oneOf(FILTERS)),
}